import { ReactElement, useState } from 'react';
import { DeviceType, ParametersType, TimeSpan } from '../constants/telosair-interfaces';
import Deque from '../classes/deque';
import Tabs from '../controls/Tabs';
import HistogramWidget from './histogram/HistogramWidget';
import { transformDataForPlotByQueues } from '../_helpers/graph';
import DashboardHeatmapWidget from './DashboardHeatMapWidget';

type HistogramWidgetProps = {
  timeSpan: TimeSpan;
  extendedLabel: string;
  onChangeParameter: (value: ParametersType[]) => void;
  lineChartGraphData: Record<ParametersType, Deque>;
  loading: boolean;
  expanded: boolean;
  type: DeviceType;
};

const TAB_HISTOGRAM = 'TAB_HISTOGRAM';
const TAB_THRESHOLD = 'TAB_THRESHOLD';

const TabList = [
  {
    id: TAB_HISTOGRAM,
    name: 'Time Series',
    info: 'Line chart showing the average data for each parameter across all devices. Use the first dropdown at the top of the dashboard to filter it.'
  },
  {
    id: TAB_THRESHOLD,
    name: 'Threshold Timeline',
    info: 'The threshold timeline displays the threshold values for all parameters. Use the first dropdown at the top of the dashboard to filter it.'
  }
];
/**
 * Displays a histogram of parameter values and allows users to switch between parameters.
 * @param props - HistogramWidgetProps.
 * @returns A React element representing the Histogram component.
 */
export default function DashboardCharts(props: HistogramWidgetProps): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    timeSpan,
    extendedLabel,
    lineChartGraphData,
    onChangeParameter,
    loading,
    expanded,
    type
  } = props;
  const [selectedTab, setSlectedTab] = useState(TAB_HISTOGRAM);

  return (
    <div className="p-4 pt-2 gap-2 w-full flex-1 flex flex-col relative h-full bg-container-500 rounded">
      {/* <div className="absolute border-l border-l-gray-500 top-16 bottom-12 left-[-0.625rem]" /> */}
      <div className="flex items-center justify-between">
        <Tabs
          tabType="fit"
          fontStyle="text-base font-medium"
          tabs={TabList}
          selectedTab={selectedTab}
          onTabClick={(tab) => setSlectedTab(tab)}
        />
        <span className="text-sm font-regular text-gray-400  cursor-default">{extendedLabel}</span>
      </div>
      {selectedTab === TAB_HISTOGRAM && (
        <HistogramWidget
          extendedLabel={extendedLabel}
          loading={loading}
          lineChartGraphData={lineChartGraphData}
          timeSpan={timeSpan}
          onChangeParameter={onChangeParameter}
          expanded={expanded}
          type={type}
        />
      )}
      {selectedTab === TAB_THRESHOLD && (
        <DashboardHeatmapWidget
          data={transformDataForPlotByQueues(lineChartGraphData)}
          extendedLabel={extendedLabel}
          timeSpan={timeSpan}
          isDataLoading={loading}
          type={type}
        />
      )}
    </div>
  );
}
